module.exports = __webpack_public_path__ + "static/media/universite_marseille.3e3e7e75.svg";